import {call, put, takeEvery} from 'redux-saga/effects'
import Api from "../services/Api";

function* fetchRentalPark(action) {
  try {
    const rentalPark = yield call(function() {
      return Api.get('/dealer/available-park', action.params);
    });
    yield put({type: 'FETCH.RENTAL_PARK.SUCCESS', rentalPark})
  } catch (error) {
    yield put({type: 'FETCH.RENTAL_PARK.FAILURE', error})
  }
}

function* saveManualRentalBooking(action) {
  try {

    const {from, to, body, rentalDetailsId} = action.params;
    const idParam = rentalDetailsId ? '/'+rentalDetailsId : ''
    yield call(function() {
      return Api.post(`/assign-rental${idParam}`, body);
    });

    yield put({type: 'SHOW.MANUAL_RENTAL_BOOKING_MODAL', params:{show:false}});
    yield put({type: 'SAVE.MANUAL_RENTAL_BOOKING.SUCCESS'})
    yield put({type: 'FETCH.RENTAL_PARK.REQUEST', params:{from, to}});
  } catch (error) {
    yield put({type: 'SAVE.MANUAL_RENTAL_BOOKING.FAILURE', error})
  }
}

function* deleteManualRentalBooking(action) {
  try {
    const {from, to, rentalDetailsId} = action.params;
    yield call(function() {
      return Api.post(`/unassign-rental/${rentalDetailsId}`);
    });

    yield put({type: 'SHOW.MANUAL_RENTAL_BOOKING_MODAL', params:{show:false}});
    yield put({type: 'DELETE.MANUAL_RENTAL_BOOKING.SUCCESS'})
    yield put({type: 'FETCH.RENTAL_PARK.REQUEST', params:{from, to}});
  } catch (error) {
    yield put({type: 'DELETE.MANUAL_RENTAL_BOOKING.FAILURE', error})
  }
}

function* fetchInterventionRentalPark(action) {
  const {id, params} = action;
  try {
    const rentalPark = yield call(function() {
      return Api.get(`/intervention/${id}/available-park`, params);
    });
    yield put({type: 'FETCH.INTERVENTION_RENTAL_PARK.SUCCESS', rentalPark})
  } catch (error) {
    yield put({type: 'FETCH.INTERVENTION_RENTAL_PARK.FAILURE', error})
  }
}

export function* watchRentalPark() {
  yield takeEvery('FETCH.RENTAL_PARK.REQUEST', fetchRentalPark);
  yield takeEvery('FETCH.INTERVENTION_RENTAL_PARK.REQUEST', fetchInterventionRentalPark);
  yield takeEvery('SAVE.MANUAL_RENTAL_BOOKING.REQUEST', saveManualRentalBooking);
  yield takeEvery('DELETE.MANUAL_RENTAL_BOOKING.REQUEST', deleteManualRentalBooking);
}

